module.exports = __webpack_public_path__ + "static/media/9.b63fed10.JPG";